import { useStore } from "@nanostores/react";
import {
  navigationState,
  setTransitioning,
  setCurrentSection,
  type SectionName,
} from "@/stores/navigationStore";

export const useNav = () => {
  const navState = useStore(navigationState);

  const navigateToSection = (targetSection: SectionName) => {
    // Начинаем переход
    setTransitioning(true);

    // Через 400ms меняем раздел и завершаем переход
    setTimeout(() => {
      setCurrentSection(targetSection);
      setTransitioning(false);
    }, 400);
  };

  return {
    isTransitioning: navState.isTransitioning,
    currentSection: navState.currentSection,
    navigateToSection,
  };
};
